import { Email } from '@/models'
import { BaseService, type IAuthService } from '@/services'
import { NotificationBaseURL, NotificationScopes } from '@/services/Notification'
export class NotificationService extends BaseService {
	constructor(authService: IAuthService) {
		super(NotificationBaseURL, authService, NotificationScopes)
	}

	async sendClientIntakeEmail(email: Email): Promise<string> {
		// Create a vue instance with email data
		return this.postData<Email, string>(`${NotificationBaseURL}mail/send-email`, email)
			.then((res) => {
				return res
			})
			.catch((err) => {
				throw err
			})
	}
}
